export default __webpack_public_path__ + "static/media/elsevier.b1a34bef.png";